import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { AngularModule } from '../../../modules/angular.module';
import { NavigationService } from '../../../services/navigation.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LoggedInService } from '../../../services/logged-in.service';

@Component({
	selector: 'app-avatar',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './avatar.component.html',
	styleUrl: './avatar.component.scss',
})
export class AvatarComponent {
	constructor(
		public nav: NavigationService,
		public authService: AuthService,
		private message: NzMessageService,
		private loggedInService: LoggedInService
	) {}

	public logout(): void {
		this.loggedInService.logout();
		this.message.info('You have been logged out.');
	}
}
